import type {
  FindOAuthConnectedAppsOutput,
  RevokeOAuthConnectedAppOutput,
  VerifiedOAuthVendorKey,
} from "schemas/generated/publicMcpOAuth";
import type { RequestFn } from "./request";

import { oauthEndpointContracts } from "schemas/bedrockApi/oauth";

export function createOAuthConnectedAppsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({
      cursor,
    }: {
      cursor: string | null;
    }): Promise<FindOAuthConnectedAppsOutput> => {
      return request<FindOAuthConnectedAppsOutput>({
        method: "GET",
        path: oauthEndpointContracts.connectedAppsList.path,
        query: { cursor: cursor ?? undefined },
      });
    },
    async getMcpClientConnectionStatuses(): Promise<
      Record<VerifiedOAuthVendorKey, boolean>
    > {
      const connected = { claude: false, chatgpt: false, muse: false };
      let cursor: string | null = null;
      do {
        const page = await this.find({ cursor });
        for (const app of page.apps) {
          if (app.verification.status === "verified") {
            connected[app.verification.vendor.key] = true;
          }
        }
        cursor = page.nextCursor;
      } while (cursor && !Object.values(connected).every(Boolean));
      return connected;
    },
    revoke: ({
      grantId,
    }: {
      grantId: string;
    }): Promise<RevokeOAuthConnectedAppOutput> => {
      return request<RevokeOAuthConnectedAppOutput>({
        method: "DELETE",
        path: oauthEndpointContracts.connectedAppRevoke.path.replace(
          "{grantId}",
          encodeURIComponent(grantId),
        ),
      });
    },
  };
}
